import callAPiBase from './base';

const schoolSettingsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/schoolSettingsGet',
      method: 'GET',
      useToken: true,
      title: 'School Settings - Get',
      params,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolSettingsUpdate',
      method: 'POST',
      useToken: true,
      title: 'School Settings - Update',
      data,
    }),

  updateIndividual: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolSettingsIndividualUpdate',
      method: 'POST',
      useToken: true,
      title: 'School Settings - Update Individual',
      data,
    }),
};

export { schoolSettingsApi };
export default schoolSettingsApi;
